import { Grid } from "@mui/material";
import { Stack } from "@financeable-com-au/financeable-ui";
import { AssetDealDetailsProps, AssetTypeProps } from "@/utils/interface";
import { getAssetFieldAnchorId } from "@/utils/commonFunctions";
import { ASSET_FIELD } from "./assetRequiredFields";
import { typeOfSaleList } from "../../constants";
// @ts-expect-error: ignoring as it is existing js file
import { NumericFormatCustom, currencyMaskedValue } from "../../utils/currencyMaskFormat";
import FormInputField from "../CommonComponents/FormInputField";
import FormSelectField from "../CommonComponents/FormSelectField";

const AssetDealDetails = ({
  assetId,
  assetTypesList,
  searchVehicleLoader,
  allValues,
  getLocalAndLenderError,
  handle,
  isDisableEdit,
}: AssetTypeProps) => {
  return (
    <Stack style={{ margin: "10px 0 0 0" }}>
      <Grid container spacing={1} xs={12} sm={12} md={12} direction="row">
        <FormInputField
          id={getAssetFieldAnchorId(ASSET_FIELD.assetValue, assetId)}
          fieldName="assetValue"
          label="Purchase price"
          value={allValues?.assetValue}
          error={!!getLocalAndLenderError({ fieldName: "assetValue" })}
          helperText={getLocalAndLenderError({ fieldName: "assetValue" })}
          disabled={searchVehicleLoader || isDisableEdit}
          onChange={handle.onChangeField}
          onBlur={(fieldName, value) => handle.blurFn(fieldName, currencyMaskedValue(value))}
          gridProps={{ md: 3, sm: 3, xs: 12 }}
          InputProps={{
            inputComponent: NumericFormatCustom,
          }}
        />

        <FormSelectField
          id={getAssetFieldAnchorId(ASSET_FIELD.assetType, assetId)}
          fieldName="assetTypeValue"
          label="Asset type"
          value={allValues?.assetTypeValue}
          error={!!getLocalAndLenderError({ fieldName: "assetType", localFieldName: "assetTypeValue" })}
          helperText={getLocalAndLenderError({ fieldName: "assetType", localFieldName: "assetTypeValue" })}
          disabled={searchVehicleLoader || isDisableEdit}
          options={assetTypesList.map((asset: AssetDealDetailsProps) => ({
            label: asset.label,
            value: asset.label,
          }))}
          onChange={handle.onChangeField}
          gridProps={{ md: 6, sm: 6, xs: 12 }}
        />

        <FormSelectField
          id={getAssetFieldAnchorId(ASSET_FIELD.typeOfSale, assetId)}
          fieldName="typeOfSale"
          label="Type of sale"
          value={allValues?.typeOfSale}
          error={!!getLocalAndLenderError({ fieldName: "typeOfSale" })}
          helperText={getLocalAndLenderError({ fieldName: "typeOfSale" })}
          disabled={searchVehicleLoader || isDisableEdit}
          options={Object.entries(typeOfSaleList).map(([key, value], index) => ({
            label: value,
            value,
            ...(index === 0 && { default: true }),
          }))}
          onChange={handle.onChangeField}
          gridProps={{ md: 3, sm: 3, xs: 12 }}
        />
      </Grid>
    </Stack>
  );
};

export default AssetDealDetails;
